import { isEmptyValue } from 'aa_common/front-end/helpers'
import { PresenterDepreciationMonthlyResponse, PresenterFixedAssetDepreciationResponse } from 'common/open-api'

export const isAcceleratedMonth = (month: PresenterDepreciationMonthlyResponse) => {
  return (
    !isEmptyValue(month?.depreciation_amount) &&
    !isEmptyValue(month?.original_depreciation_amount) &&
    month?.depreciation_amount !== month?.original_depreciation_amount
  )
}

export const getAcceleratedDates = (depreciationResults: PresenterFixedAssetDepreciationResponse) => {
  let startYear = depreciationResults.data?.[0]?.fiscal_year
  let startMonth = depreciationResults.data?.[0]?.months?.[0]?.month
  let foundStartDate = false

  depreciationResults.data?.forEach(depreciation => {
    if (foundStartDate) {
      return
    }

    depreciation?.months?.forEach(month => {
      if (foundStartDate || !isAcceleratedMonth(month)) {
        return
      }
      foundStartDate = true
      startMonth = month?.month
      startYear = depreciation?.fiscal_year
    })
  })

  return {
    startMonth,
    startYear,
  }
}
